import { useTranslation } from 'react-i18next';
import BasicPageTemplate from '@/shared/templates/basic-page';
import { Text } from '@metaicg/sensei-ui';
import { Hero } from './styles';
import Logo from '@/shared/components/logo/logo';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <BasicPageTemplate title={t('common:components.nav.main.home')}>
      <Hero>
        <Logo width={190} height={190} />
        <Text className="title">{t('login:components.hero.title')}</Text>
        <Text className="description" color="neutral.palette200">
          {t('login:components.hero.description')}
        </Text>
      </Hero>
    </BasicPageTemplate>
  );
};

export default HomePage;
